  import React, { useEffect, useState } from 'react';

  import ComboBox from '../../../../../components/ComboBox';
  import CollapsableSection from '../../../../../components/CollapsibleSection';
  import ButtonForm from '../../../../../components/ButtonForm';
  import InputForm from '../../../../../components/InputForm';
import WidgetHeaderStyleFields from '../../../../../components/WidgetHeaderStyleFields';
  import SelectableList from '../../../../../components/SelectableList';
  import SelectionForm from '../../../../../components/SelectionForm';

  import CheckIco from '../../../../../components/icons/CheckIco';
  import TrashIco from '../../../../../components/icons/TrashIco';
  import AddIco from '../../../../../components/icons/AddIco';

  import Spinner from '../../../../../components/Spinner';
  import { useAuth } from '../../../../../providers/AuthContext';
  import { useNavigate } from 'react-router-dom';
  import { getAllParameters } from '../../../../../services/apiProcessParameteres';
  import { useAppContext } from '../../../../../providers/AppContext';
  import { useProcesses } from '../../../../../providers/ProcessesContext';
  import { translateDatePicker } from '../../../../utils';
  import { useDashboards } from '../../../../../providers/DashboardContext';
  import { useWidgets } from '../../../../../providers/WidgetContext';
  import { createWidget, getWidgetById, updateWidget } from '../../../../../services/apiWidgests';
  import { type } from '@testing-library/user-event/dist/type';


  const ColumnField = ({ header , onDelete=() =>{}}) => {
    return (
      <div className='flex justify-between items-center w-full mr-3'>
        <div className='flex basis-1/3 items-center gap-1'>
          <span>{header.alias}</span>
        </div>
        <span className='basis-1/3 text-gray-400'>{header.key}</span>
        <button className="" onClick={() => onDelete(header)}>
          <TrashIco fill='red' />
        </button>
      </div>
    );
  };

  function HorizontalBarChartForm({onSubmit = () => {}, id}) {
    const {auth} = useAuth();
    const {addToast} = useAppContext();
    const navigate = useNavigate();

    const { addCard, assignSpace } = useWidgets();
    const { dashboard } = useDashboards();

    const [processList, setProcessList] = useState([]);
    const [selectedProcess, setSelectedProcess] = useState();
    const [parameters, setParameters] = useState();
    const [conf, setConf] = useState();
    const {menuItems} = useProcesses();
    const [verticalAxis, setVerticalAxis] = useState();
    const [horizontalAxis, setHorizontalAxis] = useState();
    const [dataRange, setDataRange] = useState('Asignar por dashboard');
    const [timeVariable, setTimeVariable] = useState("createdAt");
    const [title, setTitle] = useState('');
    const [validate, setValidate] = useState(false);
    const [stage,setStage] = useState("form");
    const [newRule, setNewRule] = useState({});

    const [variableTimeOptions, setVariableTimeOptions] = useState(
      {"createdAt": "Fecha de creación"}
    )

    //colores
    const colorOptions = {
      "pastel": "Paleta pastel",
      "blue": "Paleta azul",
      "red": "Paleta roja",
      "fixed": "Color fijo"
    }
              
    //backend flags
    const [loading, setLoading] = useState(true);
    const [fetchingParameters, setFetchingParameters] = useState(true);
    const [creatingWidget, setCreatingWidget] = useState(false);
    const [fetchingWidgetInfo, setFetchingWidgetInfo] = useState(true);

    //obtener info existente del widget
    const refreshWidgetInfo = () => {
      async function fetchWigdet(){
        const widget = await getWidgetById(id, auth?.token);
        return widget; 
      }
      try {
        setFetchingWidgetInfo(true);
        fetchWigdet().then(response => {
          console.log(response.configuration)
          setConf(response.configuration)
          setSelectedProcess(response.configuration.process.id)
          setHorizontalAxis(response.configuration.horizontalAxis)
          setVerticalAxis(response.configuration.verticalAxis)
          setTimeVariable(response.configuration.timeVariable)
          //setDataRange(response.configuration.dateRange.selectedRange === "byDashboard" ? "Asignar por dashboard": response.configuration.dateRange.selectedRange)
          setFetchingWidgetInfo(false);
          setTitle(response.title)
        }).catch(error => {
          if (error.response.status === 404){
            console.log("Widget no encontrado")
          }
          else if (error.response.status === 500){
            console.log("Error en el servidor, intente nuevamente")
          }
          else{
            navigate('/logout')
          }
        })
      } catch (error) {
        console.log(error,typeof(error));
        setFetchingWidgetInfo(false);
      }
    }

    const refreshParameters = () => {
      async function fetchParameters(){
        const parameters = await getAllParameters(selectedProcess, auth?.token);
        return parameters;
      }
      try {
        setFetchingParameters(true);
        fetchParameters().then(response => {
          console.log(console.log(response))
          let timeVars = {}
          setParameters(response.map(parameter => {
            //añadir variables de tiempo a la lista
            if (parameter.datatype === "date"){
              timeVars[parameter.key] = parameter.alias || parameter.key
            }
            return {
              key: parameter.key,
              alias: parameter.alias,
              type: parameter.datatype
            }
          }));
          //actualizar variables de tiempo
          setVariableTimeOptions({
            "createdAt": "Fecha de creación",
            ...timeVars
          })
          setFetchingParameters(false);
        }).catch(error => {
          if (error.response.status === 404){
            addToast("Proceso no encontrado",3)
          }
          else if (error.response.status === 500){
            addToast("Error en el servidor, intente nuevamente",2)
          }
          else if (error.response.status === 419){
            addToast("Sesión expirada",1)
            navigate('/logout')
          }
          else{
            navigate('/logout')
          }
        })
      } catch (error) {
        console.log(error, "a", typeof(error));
        setFetchingParameters(false);
      }
    }

    const createWidgetDB = () => {
      async function fetchWidget(){
        const position= assignSpace();
        const widget = await createWidget({
          type: "processHorizontalBarChart",
          title: title,
          description: "",
          configuration: conf,
          dashboardId: dashboard._id,
          x: position.x,
          y: position.y,
          width: 200,
          height: 200,
        }, auth?.token);
        
        return widget;
      }
      try {
        setCreatingWidget(true);
        fetchWidget().then(response => {
          console.log(console.log(response));
          addCard (
            response._id,
            response.title,
            response.type,
            response.dashboardId,
            
          )
          onSubmit();
          setCreatingWidget(false);
          addToast("Widget "+ title + " creado exitosamente.",1)
        }).catch(error => {
          console.log(error)
          if (error.response.status === 404){
            addToast("Proceso no encontrado",3)
          }
          else if (error.response.status === 500){
            addToast("Error en el servidor, intente nuevamente",2)
          }
          else if (error.response.status === 419){
            addToast("Sesión expirada",1)
            navigate('/logout')
          }
          else{
            navigate('/logout')
          }
        })
      } catch (error) {
        console.log(error, "a", typeof(error));
        setCreatingWidget(false);
      }
    }

    const editWidgetDB = () => {
      async function saveWidget(){

        const widget = await updateWidget(id,{
          type: "processHorizontalBarChart",
          title: title,
          description: "",
          configuration: conf,
          /* dashboardId: dashboard._id,
          x: position.x,
          y: position.y,
          width: 200,
          height: 200, */
        }, auth?.token);
        
        return widget;
      }
      try {
        setCreatingWidget(true);
        saveWidget().then(response => {
          console.log(console.log(response));
          
          onSubmit();
          setCreatingWidget(false);
          addToast("Widget "+ title + " editado exitosamente.",1);
        }).catch(error => {
          console.log(error)
          if (error.response.status === 404){
            addToast("Proceso no encontrado",3)
          }
          else if (error.response.status === 500){
            addToast("Error en el servidor, intente nuevamente",2)
          }
          else if (error.response.status === 419){
            addToast("Sesión expirada",1)
            navigate('/logout')
          }
          else{
            navigate('/logout')
          }
        })
      } catch (error) {
        console.log(error, "a", typeof(error));
        setCreatingWidget(false);
      }
    }

    const selectAxisV = (selectedItems) => {
      if (parameters && selectedItems){
        const axisV = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.verticalAxis = axisV
        setConf({...tempConf})
      }
      
    }
    const deleteAxisV = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.verticalAxis = undefined
        setConf({...tempConf})
      } 
    }
    const selectAxisH = (selectedItems) => {
      if (parameters && selectedItems){
        const axisH = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.horizontalAxis = axisH
        setConf({...tempConf})
      }
    }

    const selectColorPalette = (selectedColor) => {
      if (selectedColor){
        let tempConf = {...conf}
        tempConf.colorPalette = selectedColor
        setConf({...tempConf})
      }
    }
    const selectFixedColor = (selectedColor) => {
      if (selectedColor){
        let tempConf = {...conf}
        tempConf.fixedColor = selectedColor
        setConf({...tempConf})
      }
    }
    const selectTextColor = (selectedColor) => {
      if (selectedColor){
        let tempConf = {...conf}
        tempConf.textColor = selectedColor
        setConf({...tempConf})
      }
    }
    const selectGroupList = (selectedItems) => {
      if (parameters && selectedItems){
        const groupList = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.groupList = groupList
        setConf({...tempConf})
      }
    }
    const selectFilterList = (selectedItems) => {
      if (parameters && selectedItems){
        const filterList = parameters.find( element => {return selectedItems.includes( element.alias || element.key)});
        let tempConf = {...conf}
        tempConf.filterList = filterList
        setConf({...tempConf})
      }
    }

    // --- FILTROS AVANZADOS ---
      const translateSpanishToCode = (spanish) => {
      switch(spanish) {
        case "Igual a": return "eq";
        case "Diferente de": return "ne";
        case "Mayor a": return "gt";
        case "Menor a": return "lt";
        case "Mayor o igual": return "gte";
        case "Menor o igual": return "lte";
        case "En lista": return "in";
        default: return "";
      }
    };

    const translateRuleCodeToSpanish = (code) => {
      switch(code) {
        case "eq": return "Igual a";
        case "ne": return "Diferente de";
        case "gt": return "Mayor a";
        case "lt": return "Menor a";
        case "gte": return "Mayor o igual";
        case "lte": return "Menor o igual";
        case "in": return "En lista";
        default: return "";
      }
    };

      const handleAddFilterRule = (ruleCode, ruleValue) => {
      setConf(prev => {
        const newRules = prev.filterList?.rules ? [...prev.filterList.rules] : [];
        newRules.push({ code: ruleCode, value: ruleValue });
        return { ...prev, filterList: { ...prev.filterList, rules: newRules } };
      });
    };

    const handleSetFilterField = (field) => {
      setConf(prev => ({
        ...prev,
        filterList: { ...prev.filterList, field }
      }));
    };

    const handleRemoveFilterRule = (index) => {
      setConf(prev => {
        const newRules = [...prev.filterList.rules];
        newRules.splice(index, 1);
        return { ...prev, filterList: { ...prev.filterList, rules: newRules } };
      });
    };

    const handleClearFilter = () => {
      setConf(prev => ({
        ...prev,
        filterList: undefined
      }));
    };
    const deleteAxisH = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.horizontalAxis = undefined
        setConf({...tempConf})
      } 
    }
    const deleteFilterList = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.filterList = undefined
        setConf({...tempConf})
      } 
    }
    const deleteGroupList = (selectedItems) => {
      if (parameters && selectedItems){
        let tempConf = {...conf}
        tempConf.groupList = undefined
        setConf({...tempConf})
      } 
    }
  
    const handleProcessChange = (selectedProcess) => {
      let tempConf = {...conf}
      tempConf.verticalAxis = undefined;
      tempConf.horizontalAxis = undefined;
      tempConf.process = {
        id: selectedProcess,
        name: processList[selectedProcess]
      }
      setConf({...tempConf})
    }

    const handleDataRangeChange = (selectedRange) => {
      setDataRange(translateDatePicker(selectedRange));
      let tempConf = {...conf}
      tempConf.dateRange = selectedRange
      setConf({...tempConf})
    }

    const handleTimeVariableChange = (selectedTimeVar) => {
      setTimeVariable(selectedTimeVar);
      let tempConf = {...conf}
      tempConf.timeVariable = selectedTimeVar
      setConf({...tempConf})
    }
    const handleDecimalsChange = (decimals) => {
      let tempConf = {...conf}
      tempConf.nDecimals = decimals
      setConf({...tempConf})
    }
    const handleChangeWidgetName = (name) => {
      setTitle(name)
    }
    const handleCreateWidget = () =>{
      
      //createCard("processTable",title, conf, dashboard._id);
      createWidgetDB();
      
    }
    const handleEditWidget = () =>{
      editWidgetDB();
    }

    useEffect( () => {
      if (selectedProcess){
        //limpiar headers actuales
          
        //cargar los parametros
        refreshParameters();
        //actualizar la configuracion
        handleProcessChange(selectedProcess);

      }
    }, [selectedProcess]);
    useEffect( () => {

        const bdConf = {
          process: undefined,
          verticalAxis: undefined,
          horizontalAxis: undefined,
          groupList: undefined,
          filterList:  undefined, 
          dateRange: {
            "activeTab": "customDates",
            "selectedRange": "byDashboard"
          },
          timeVariable: "createdAt",
          nDecimals: 2,
          dateFormat: "mm/dd/yy - hh:mm",
          colorPalette: "fixed",
          fixedColor: "#4287f5",
          textColor: "#000000"
        }
    
        setLoading(true);
        //cargar campos
        //cargar conf
        let processOptions = {}
        menuItems.slice(1).map(element => 
          processOptions[element.id] = element.label
        )
        console.log(processOptions);
        if(id) {
          refreshWidgetInfo()
        }
        else{
          setConf(bdConf);
          
        }
        setProcessList(processOptions);
        setLoading(false);
      }, []);


    useEffect( () => {
      if (id){
        refreshWidgetInfo()
      }
      setFetchingWidgetInfo(false)
      
    }, [id])

    useEffect( () => {
      if (
        title === "" ||
        !conf?.process ||
        !conf.horizontalAxis ||
        !conf.verticalAxis ||
        !conf?.dateRange ||
        !conf?.timeVariable ||
        !conf?.nDecimals
      ){
        setValidate(false);
      }
      else {
        setValidate(true);
      }
    }, [conf, title])

    return (
      <>
      {stage === "form" && (
        <>
          {conf && (
              <div className='flex flex-col gap-2 h-[35rem] relative overflow-auto'>
              <div className=' flex flex-col flex-grow gap-2'>
                <CollapsableSection title={"Datos"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' open={true} border={false}>
                  <div className='flex flex-col gap-2'>
                    <div className='flex justify-between items-center w-[50%] mb-1.5'>
                      <SelectionForm
                        text="Proceso" 
                        options={Object.keys(processList)} 
                        mask={processList} 
                        value={selectedProcess}
                        onChange={event => setSelectedProcess(event)}
                        AppendClassName=' -mb-4'
                        error={!!selectedProcess && !fetchingParameters && parameters.length === 0 ? 'El proceso no tiene parametros creados' : ""}
                      /> 
                    
                    </div>
                  
                      <CollapsableSection 
                        title={"Etiqueta"}
                        titleBgColor='bg-aliceblue'
                        titleTextColor='text-gray'
                        open={true}
                      >
                        <div className='w-full flex flex-col px-4'>
                          { conf.verticalAxis && (
                            <ColumnField header={conf.verticalAxis} onDelete={deleteAxisV}/>
                          )}
                          { !conf.verticalAxis && (
                            <div className=' mx-auto'>
                              <ButtonForm 
                                text={"Agregar campo"} 
                                Icon={() => {return (<AddIco fill='white'/>)}} 
                                enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                                action={ () => setStage("setVerticalAxis")}
                              />
                            </div>
                          )}
                        </div>
                      </CollapsableSection>

                      <CollapsableSection
                        title={"Valor (datos numéricos)"}
                        titleBgColor='bg-aliceblue'
                        titleTextColor='text-gray'
                        open={true}
                      >
                        <div className='w-full flex flex-col px-4'>
                          { conf.horizontalAxis && (
                            <ColumnField header={conf.horizontalAxis} onDelete={deleteAxisH}/>
                          )}
                          { !conf.horizontalAxis && (
                            <div className=' mx-auto'>
                              <ButtonForm 
                                text={"Agregar campo"} 
                                Icon={() => {return (<AddIco fill='white'/>)}} 
                                enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                                action={ () => setStage("setHorizontalAxis")}
                              />
                            </div>
                          )}
                        </div>
                      </CollapsableSection>

                      <CollapsableSection
                        title={"Agrupar por"}
                        titleBgColor='bg-aliceblue'
                        titleTextColor='text-gray'
                        open={true}
                      >
                        <div className='w-full flex flex-col px-4'>
                          { conf.groupList && (
                            <ColumnField header={conf.groupList} onDelete={deleteGroupList}/>
                          )}
                          { !conf.groupList && (
                            <div className=' mx-auto'>
                              <ButtonForm 
                                text={"Agregar campo"} 
                                Icon={() => {return (<AddIco fill='white'/>)}} 
                                enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                                action={ () => setStage("setGroupList")}
                              />
                            </div>
                          )}
                        </div>
                      </CollapsableSection>

                      <CollapsableSection
                        title={"Filtrar por"}
                        titleBgColor='bg-aliceblue'
                        titleTextColor='text-gray'
                        open={true}
                      >
                        <div className='w-full flex flex-col px-4'>
                          { !!conf.filterList && (
                            <ColumnField header={conf.filterList} onDelete={deleteFilterList}/>
                          )}
                          { conf.filterList !== [] && (
                            <div className=' mx-auto'>
                              <ButtonForm 
                                text={"Agregar campo"} 
                                Icon={() => {return (<AddIco fill='white'/>)}} 
                                enabled={!!selectedProcess && !fetchingParameters && parameters.length!== 0}
                                action={ () => setStage("setFilterList")}
                              />
                            </div>
                          )}
                        </div>
                      </CollapsableSection>
                    
                    <div className='-mb-5 '>
                      <InputForm 
                        type={"datarange"} 
                        text={"Rango de tiempo"} 
                        value={dataRange} 
                        AppendClassName='text-left' 
                        onChange={(event) => handleDataRangeChange(event)}
                        dateRangeOptions={conf.dateRange}
                        addedRanges={ {"byDashboard": () => {}}} 
                      />
                    </div>

                    <div className='-mb-5 '>
                      <SelectionForm
                        text="Variable de tiempo" 
                        options={Object.keys(variableTimeOptions)} 
                        mask={variableTimeOptions}
                        value={timeVariable}
                        onChange={event => handleTimeVariableChange(event)}
                        AppendClassName=''
                        error={!!selectedProcess && !fetchingParameters && parameters.length === 0 ? 'El proceso no tiene variables de tiempo' : ""}
                      /> 
                    </div>
                    
                  </div>
                </CollapsableSection>
                <CollapsableSection title={"Apariencia"} titleBgColor='bg-lightblue' titleTextColor='text-bluesens' border={false} open={true}>
                  <InputForm text={"Nombre"} value={title} onChange={(event) => setTitle(event.target.value)}/>
                  <InputForm type={"number"} text={"Decimales"} value={conf.nDecimals} onChange={(event) => handleDecimalsChange(event.target.value)}/>
                  <InputForm type={"button"} text={"Estilo"} value={"Modificar estilo"} AppendClassName='text-left' onClick={() => {setStage("setAparience")}}/>
                </CollapsableSection>
              </div>

              {/* Span fijo al final del contenedor */}
              <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
                <div className='flex w-full justify-end'>
                    <button className='' onClick={() => id ? handleEditWidget() : handleCreateWidget()}  disabled={!validate}>
                      <CheckIco width='50px' height='50px' fill={validate ? 'bluesens': 'gray'}/>
                    </button>
                </div>
              </div>
            </div>
          )}
          {!conf && (
            <Spinner />
          )}
        </>
        
        
      )}
      {stage === "setVerticalAxis" && (
        <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
          <div className=' flex flex-col flex-grow gap-2'>
            <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
              <SelectableList 
                items={parameters.filter(element => !element.type ).map(element => element.alias ? element.alias : element.key)} 
                multiSelect={false} 
                setItems={selectAxisV}
              />
          </div>
          
          {/* Span fijo al final del contenedor */}
          <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
            <div className='flex w-full justify-end'>
              < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
            </div>
          </div>
        </div>
      )}
      {stage === "setHorizontalAxis" && (
        <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
          <div className=' flex flex-col flex-grow gap-2'>
            <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
            <SelectableList 
              items={parameters.filter(element => element.type === "numeric" || element.type === "time" ).map(element => element.alias ? element.alias : element.key)} 
              multiSelect={false} 
              setItems={selectAxisH}
            />
          </div>
          
          {/* Span fijo al final del contenedor */}
          <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
            <div className='flex w-full justify-end'>
              < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
            </div>
          </div>
        </div>
      )}

      {stage === "setGroupList" && (
        <div className='flex flex-col gap-2 h-[25rem] relative overflow-auto '>
          <div className=' flex flex-col flex-grow gap-2'>
            <span className='font-semibold text-lg'>{processList[selectedProcess]}</span>
            <SelectableList 
              items={parameters.filter(element => !element.type  ).map(element => element.alias ? element.alias : element.key)} 
              multiSelect={false} 
              setItems={selectGroupList}
            />
          </div>
          
          {/* Span fijo al final del contenedor */}
          <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
            <div className='flex w-full justify-end'>
              < ButtonForm text={"Guardar"} enabled={true} action={() => setStage('form')}/>
            </div>
          </div>
        </div>
      )}

      {stage === "setFilterList" && (
          <div className='flex flex-col  h-[25rem] relative overflow-auto'>
            <div className='flex flex-col flex-grow gap-2'>
              <span className='font-semibold text-lg'>Selecciona un campo para filtrar</span>

              {/* Selección del campo */}
              <SelectionForm
                text="Campo"
                options={parameters.map(p => p.key)}
                value={conf.filterList?.field || ""}
                onChange={selectedField => {
                  handleSetFilterField(selectedField);
                }}
              />

              {/* Agregar nueva regla */}
                <div className='flex w-full  items-center gap-2 mt-2'>
                  <div className='w-[40%]'>
                    <SelectionForm
                      text="Regla"
                      options={["Igual a", "Diferente de", "Mayor a", "Menor a", "Mayor o igual", "Menor o igual", "En lista"]}
                      value={""}
                      onChange={selectedRule => setNewRule({ ...newRule, code: translateSpanishToCode(selectedRule) })}
                    />
                  </div>
                  <div className='w-[20%]'>
                    <InputForm
                      type="text"
                      placeholder="Valor"
                      value={newRule.value || ""}
                      onChange={e => setNewRule({ ...newRule, value: e.target.value })}
                    
                    />
                  </div>
                  <div className='w-[20%] flex items-center justify-center'>
                    <button
                      className='bg-bluesens text-white px-2 py-1 rounded'
                      onClick={() => {
                        handleAddFilterRule(newRule.code, newRule.value);
                        setNewRule({}); // limpiar input
                      }}
                      disabled={!newRule.code || !newRule.value}
                    >
                      Agregar regla
                    </button>
                  </div>
                  
                </div>

              {/* Reglas */}
              <div className='flex flex-col gap-2 mt-2'>
                {conf.filterList?.rules?.map((rule, index) => (
                  <div key={index} className='flex items-center gap-2'>
                    <span className='font-medium'>{index + 1}.</span>
                    <span>{translateRuleCodeToSpanish(rule.code)}</span>
                    <span>=</span>
                    <span>{rule.value}</span>
                    <button
                      className='text-red-500 ml-2'
                      onClick={() => handleRemoveFilterRule(index)}
                    >
                      Eliminar
                    </button>
                  </div>
                ))}

                
              </div>
            </div>

            {/* Span fijo al final */}
            <div className='flex-none sticky bottom-0 bg-white p-2 shadow-lg'>
              <div className='flex w-full justify-end'>
                <ButtonForm text={"Guardar"} enabled={!!conf.filterList?.field} action={() => setStage('form')} />
              </div>
            </div>
          </div>
        )}

      {/* Apariencia */} 
      {stage === "setAparience" && (
        <div className="flex flex-col gap-2 h-[25rem] relative overflow-auto">
          <div className="flex flex-col flex-grow gap-2">
            <span className="font-semibold text-lg">Modificar estilo</span>
            <div className="pt-2">
              <WidgetHeaderStyleFields
                headerColor={conf?.headerColor}
                headerTextColor={conf?.headerTextColor}
                onChange={(field, val) => setConf(prev => ({ ...prev, [field]: val }))}
              />
            </div>

            {/* Selección de paleta de colores */}
            <span className='text-sm font-medium text-gray-500 mt-1'>Gráfico</span>
            <SelectionForm
              id="colorPalette"
              text="Paleta de colores"
              options={Object.keys(colorOptions)}
              mask={colorOptions}
              value={conf?.colorPalette || "pastel"}
              onChange={(event) => selectColorPalette(event)}
            compact
            />

            {/* Mostrar el color fijo solo si se selecciona esa opción */}
            {conf?.colorPalette === "fixed" && (
              <InputForm
                id="fixedColor"
                type="color"
                text="Seleccionar color fijo"
                value={conf?.fixedColor || "#4287f5"}
                onChange={(event) => selectFixedColor(event)}
              compact
              />
            )}
            <InputForm
              id="textColor"
              type="color"
              text="Seleccionar color del texto"
              value={conf?.textColor || "#000000"}
              onChange={(event) => selectTextColor(event)}
            compact
            />
          </div>

          {/* Botón fijo al final */}
          <div className="flex-none sticky bottom-0 bg-white p-2 shadow-lg">
            <div className="flex w-full justify-end">
              <ButtonForm
                text={"Guardar"}
                enabled={true}
                action={() => setStage("form")}
              />
            </div>
          </div>
        </div>
      )}

      </>
    
      
    );
  }

  export default HorizontalBarChartForm;
